// src/locales/German/de.accountSupport.ts

const accountSupport = {
accountSupport: {
  meta: {
    title: "Kontohilfe",
    subtitle:
      "Hier finden Sie Hilfe zu Kontozugriff, Einstellungen, Datenschutz, Sicherheit und Support.",
    back: "Zurück",
    overviewTitle: "Hilfe & Support",
    searchPlaceholder: "Kontohilfe durchsuchen"
  },

  sidebar: {
    accountOverview: "Kontoübersicht",
    registration: "Registrierung",
    login: "Anmeldung & Zugriff",
    myProfile: "Mein Profil",
    settings: "Kontoeinstellungen",
    dataPrivacy: "Daten & Datenschutz",
    security: "Sicherheit",
    profileManagement: "Profilverwaltung",
    support: "Support & Fehlerbehebung",
  },

  overview: {
    whatIsMyAccount: "Kontoübersicht",
    profileBasics: "Grundlagen des Profils",
    accountStatus: "Kontostatus",
    accountVerification: "Kontoverifizierung",

    registerNewAccount: "So registrieren Sie ein neues Konto",
    registrationEmailMissing: "Ich habe die Registrierungs-E-Mail nicht erhalten",
    registrationProblems: "Probleme bei der Registrierung",
    usernameAlreadyUsed: "Profilname wird bereits verwendet",
    emailAlreadyUsed: "E-Mail-Adresse wird bereits verwendet",
    minimumAgeRequirements: "Mindestalter",

    login: "So melden Sie sich an",
    forgotPassword: "Passwort vergessen",
    resetPassword: "Passwort ändern",
    cannotAccessAccount: "Ich kann nicht auf mein Konto zugreifen",
    accountLocked: "Konto gesperrt",
    verificationCodeIssues: "Probleme mit dem Bestätigungscode",
    loginNewDevice: "Anmeldung auf einem neuen Gerät",
    suspiciousLoginActivity: "Verdächtige Anmeldeaktivitäten",

    findingMyProfile: "Wo finde ich die Informationen zu Mein Profil?",
    profileName: "Profilname",
    changeProfilePicture: "Profilbild ändern",
    editBio: "Biografie bearbeiten",

    settingsOverview: "Kontoeinstellungen",
    shareProfileName: "Profilnamen teilen",
    changeEmail: "E-Mail-Adresse ändern",
    changePassword: "Passwort ändern",
    selectLanguage: "Sprache auswählen",
    notificationSettings: "Benachrichtigungseinstellungen",
    manageConnectedAccounts: "Verknüpfte Konten verwalten",
    logoutAllDevices: "Von allen Geräten abmelden",

    accountManagementOverview: "Übersicht zur Kontoverwaltung",
    deactivateProfile: "Profil deaktivieren",
    reactivateProfile: "Profil reaktivieren",
    deleteAccount: "Konto löschen",
    accountDeletionProcess: "Was passiert, wenn ein Konto gelöscht wird?",
    dataRetention: "Datenspeicherung",
    downloadAccountData: "Kontodaten herunterladen",

    dataPrivacyOverview: "Übersicht zu Daten & Datenschutz",
    adjustPrivacySettings: "Datenschutzeinstellungen anpassen",
    firstPrivacyChoice: "Erste Datenschutzeinstellungen nach der Registrierung",
    whoCanSeeProfile: "Wer kann mein Profil sehen?",
    whoCanContactMe: "Wer kann mich kontaktieren?",
    blockUser: "Benutzer blockieren",
    reportUser: "Benutzer melden",

    securityOverview: "Sicherheitsübersicht",
    twoFactorAuthentication: "Zwei-Faktor-Authentifizierung (2FA)",
    how2faWorks: "So funktioniert die 2FA",
    disableTwoFactorAuthentication: "Zwei-Faktor-Authentifizierung deaktivieren",
    keepingAccountSecure: "So bleibt Ihr Konto sicher",

    profileManagementOverview: "Übersicht zur Profilverwaltung",
    myFollowers: "Meine Follower",
    myFollowees: "Profile, denen ich folge",

    contactSupport: "Support kontaktieren",
    reportIssue: "Technisches Problem melden",
    websiteIssues: "Probleme mit der Website",
    accountRecovery: "Kontowiederherstellung",
    appealRestriction: "Einschränkung anfechten",
    faq: "Häufig gestellte Fragen",
  },

  sections: {

/////////////////////////////////
/////////Account Overview////////
/////////////////////////////////

    whatIsMyAccount: {
      title: "Kontoübersicht",
      body: [
        {
          type: "paragraph",
          text: "Ihr Konto ist Ihr persönlicher Zugang zur Plattform. Es enthält Ihre Profilinformationen, Anmeldedaten, Datenschutzeinstellungen, Sicherheitseinstellungen und Ihre Aktivitäten auf der gesamten Plattform.",
        },
        {
          type: "bullets",
          items: [
            "Nutzen Sie Ihr Konto, um auf Ihr Profil und die Funktionen der Plattform zuzugreifen.",
            "Erstellen und teilen Sie Beiträge mit anderen Nutzern.",
            "Chatten Sie privat mit anderen Nutzern.",
            "Verwalten Sie Ihr Profilbild, Ihre Biografie (optional) und weitere Profilinformationen.",
            "Folgen Sie anderen Profilen und interagieren Sie mit deren Inhalten.",
            "Passen Sie Ihre Datenschutz-, Benachrichtigungs- und Sicherheitseinstellungen an.",
          ],
        },
      ],
    },

    profileBasics: {
      title: "Grundlagen des Profils",
      body: [
        {
          type: "paragraph",
          text: "Ihr Profil bestimmt, wie Ihr Konto für Sie und – abhängig von Ihren Datenschutzeinstellungen – für andere Nutzer angezeigt wird.",
        },
        {
          type: "bullets",
          items: [
            "Ihr Profil enthält einen eindeutigen Profilnamen. Es kann außerdem ein Profilbild, eine Biografie und weitere sichtbare Informationen enthalten.",
            "Sie können die meisten Profildetails unter „Mein Profil“ aktualisieren. Ihr Profilname kann nach der Registrierung nicht mehr geändert werden.",
            "Sie können Ihr Profil in den Kontoeinstellungen deaktivieren. Wenn Ihr Profil deaktiviert ist, werden Ihr Profil und Ihre Beiträge für andere Nutzer ausgeblendet.",
          ],
        },
      ],
    },

/////////////////////////////////
///////////Registration//////////
/////////////////////////////////
       registerNewAccount: {
        title: "So registrieren Sie ein neues Konto",
        body: [
          {
            type: "paragraph",
            text: "Um ein Konto zu erstellen, müssen Sie mindestens 18 Jahre alt sein und über eine gültige E-Mail-Adresse verfügen. Folgen Sie den untenstehenden Schritten, um Ihre Registrierung abzuschließen und Zugriff auf die Plattform zu erhalten.",
          },
          {
            type: "steps",
            items: [
              "Geben Sie einen eindeutigen Profilnamen ein.",
              "Geben Sie eine gültige E-Mail-Adresse ein.",
              "Erstellen Sie ein sicheres Passwort mit mindestens 8 Zeichen und einer Zahl.",
              "Bestätigen Sie, dass Sie mindestens 18 Jahre alt sind, indem Sie das entsprechende Kontrollkästchen auswählen.",
              "Klicken Sie auf die Schaltfläche „Konto erstellen“.",
              "Eine Bestätigungs-E-Mail wird von register@elnydo.com gesendet.",
              "Öffnen Sie die E-Mail und klicken Sie auf den Bestätigungslink.",
              "Wählen Sie nach der erfolgreichen Bestätigung Ihre Datenschutzeinstellungen aus.",
              "Anschließend werden Sie zum Galerie-Feed weitergeleitet."
            ],
          },
          {
            type: "note",
            text: "Nur Personen ab 18 Jahren dürfen ein Konto erstellen. Sollten Sie die Registrierungs-E-Mail nicht innerhalb weniger Minuten erhalten, überprüfen Sie bitte Ihren Spam- oder Junk-Ordner, bevor Sie eine neue Bestätigungs-E-Mail anfordern.",
          },
        ],
      },

      registrationEmailMissing: {
        title: "Ich habe die Registrierungs-E-Mail nicht erhalten",
        body: [
          {
            type: "paragraph",
            text: "Falls Ihre Registrierungs-E-Mail nicht eintrifft, wurde sie möglicherweise verzögert, blockiert oder von Ihrem E-Mail-Anbieter gefiltert.",
          },
          {
            type: "steps",
            items: [
              "Überprüfen Sie Ihren Spam-, Junk-, Werbung- oder andere gefilterte Ordner.",
              "Stellen Sie sicher, dass Sie die richtige E-Mail-Adresse eingegeben haben.",
              "Versuchen Sie es mit einer anderen E-Mail-Adresse oder kontaktieren Sie den Support, wenn das Problem weiterhin besteht.",
            ],
          },
          {
            type: "note",
            text: "Teilen Sie Registrierungslinks, Anmeldecodes oder Bestätigungs-E-Mails niemals mit anderen Personen.",
          },
        ],
      },

      registrationProblems: {
        title: "Probleme bei der Registrierung",
        body: [
          {
            type: "paragraph",
            text: "Die Registrierung kann fehlschlagen, wenn erforderliche Informationen fehlen, ungültig sind, bereits verwendet werden oder der Dienst vorübergehend nicht verfügbar ist.",
          },
          {
            type: "steps",
            items: [
              "Überprüfen Sie, ob alle erforderlichen Felder ausgefüllt sind.",
              "Stellen Sie sicher, dass Ihr Profilname und Ihre E-Mail-Adresse gültig und noch nicht vergeben sind.",
              "Aktualisieren Sie die Seite oder starten Sie die App neu.",
              "Deaktivieren Sie Browser-Erweiterungen, die Formulare blockieren könnten.",
              "Kontaktieren Sie den Support, wenn das Problem weiterhin besteht.",
            ],
          },
        ],
      },

      usernameAlreadyUsed: {
        title: "Profilname wird bereits verwendet",
        body: [
          {
            type: "paragraph",
            text: "Wenn ein Profilname bereits verwendet wird, wurde er bereits für ein anderes Konto registriert oder ist nicht verfügbar.",
          },
          {
            type: "bullets",
            items: [
              "Versuchen Sie einen anderen Profilnamen.",
              "Fügen Sie Zahlen, Initialen oder eine andere Variante hinzu.",
              "Vermeiden Sie es, sich als eine andere Person, Marke oder Organisation auszugeben.",
            ],
          },
        ],
      },

      emailAlreadyUsed: {
        title: "E-Mail-Adresse wird bereits verwendet",
        body: [
          {
            type: "paragraph",
            text: "Wenn Ihre E-Mail-Adresse bereits verwendet wird, ist sie möglicherweise bereits mit einem bestehenden Konto verknüpft.",
          },
          {
            type: "steps",
            items: [
              "Versuchen Sie, sich mit dieser E-Mail-Adresse anzumelden.",
              "Nutzen Sie die Funktion zum Zurücksetzen des Passworts, wenn Sie Ihr Passwort vergessen haben.",
              "Kontaktieren Sie den Support, wenn Sie glauben, dass Ihre E-Mail-Adresse ohne Ihre Zustimmung verwendet wird.",
            ],
          },
        ],
      },

      minimumAgeRequirements: {
        title: "Mindestalter",
        body: [
          {
            type: "paragraph",
            text: "Sie müssen mindestens 18 Jahre alt sein, um ein Konto auf dieser Plattform zu erstellen und zu nutzen.",
          },
          {
            type: "bullets",
            items: [
              "Nur Personen ab 18 Jahren dürfen ein Konto erstellen.",
              "Mit der Erstellung eines Kontos bestätigen Sie, dass Sie das Mindestalter erfüllen.",
              "Konten von Personen unter 18 Jahren können entfernt werden.",
            ],
          },
        ],
      },

/////////////////////////////////
//////////Login & Access/////////
/////////////////////////////////
      login: {
        title: "So melden Sie sich an",
        body: [
          {
            type: "paragraph",
            text: "Verwenden Sie Ihre registrierte Anmeldemethode, um auf Ihr Konto zuzugreifen.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie die Anmeldeseite auf der Elnydo-Website. In der mobilen App wird der Anmeldebildschirm automatisch angezeigt, sobald Sie die App starten.",
              "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse und Ihr Passwort ein und klicken Sie anschließend auf die Schaltfläche „Anmelden“.",
              "Wenn Ihre E-Mail-Adresse und Ihr Passwort korrekt sind, werden Sie angemeldet und zum Galerie-Feed weitergeleitet.",
            ],
          },
        ],
      },

      forgotPassword: {
        title: "Passwort vergessen",
        body: [
          {
            type: "paragraph",
            text: "Wenn Sie Ihr Passwort vergessen haben, können Sie die Funktion zum Zurücksetzen des Passworts auf dem Anmeldebildschirm verwenden.",
          },
          {
            type: "steps",
            items: [
              "Wählen Sie auf der Anmeldeseite den Link „Passwort vergessen“ aus.",
              "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein.",
              "Überprüfen Sie Ihren Posteingang sowie Ihren Spam-Ordner.",
              "Folgen Sie dem Link zum Zurücksetzen und erstellen Sie ein neues Passwort.",
            ],
          },
        ],
      },

      resetPassword: {
        title: "Passwort ändern",
        body: [
          {
            type: "paragraph",
            text: "Das Ändern Ihres Passworts hilft dabei, den Zugriff auf Ihr Konto wiederherzustellen und Ihr Konto zu schützen, wenn Sie sich nicht anmelden können oder einen unbefugten Zugriff vermuten.",
          },
          {
            type: "steps",
            items: [
              "Klicken Sie in den Kontoeinstellungen auf „Passwort ändern“. Alternativ können Sie auf der Anmeldeseite die Funktion „Passwort vergessen“ verwenden.",
              "Um Ihr Passwort zu ändern, müssen Sie zunächst Ihr aktuelles Passwort eingeben.",
              "Geben Sie ein neues Passwort ein und bestätigen Sie es. Das Passwort muss mindestens 8 Zeichen und eine Zahl enthalten.",
              "Klicken Sie auf „Bestätigen“, um Ihr neues Passwort zu speichern und Ihr Konto weiter zu nutzen.",
            ],
          },
        ],
      },

      cannotAccessAccount: {
        title: "Ich kann nicht auf mein Konto zugreifen",
        body: [
          {
            type: "paragraph",
            text: "Wenn Sie nicht auf Ihr Konto zugreifen können, liegt dies möglicherweise an Ihren Anmeldedaten, einer ausstehenden Bestätigung, dem Kontostatus oder einer Sicherheitsmaßnahme.",
          },
          {
            type: "steps",
            items: [
              "Überprüfen Sie, ob Ihre E-Mail-Adresse und Ihr Passwort korrekt sind.",
              "Versuchen Sie, Ihr Passwort über den Link „Passwort vergessen“ zurückzusetzen.",
              "Prüfen Sie, ob Sie eine Benachrichtigung zu Ihrem Konto oder eine E-Mail zum Zurücksetzen des Passworts erhalten haben.",
              "Kontaktieren Sie den Support, wenn Sie weiterhin keinen Zugriff auf Ihr Konto haben.",
            ],
          },
        ],
      },

      accountLocked: {
        title: "Konto gesperrt",
        body: [
          {
            type: "paragraph",
            text: "Ein Konto kann nach verdächtigen Aktivitäten, wiederholten fehlgeschlagenen Anmeldeversuchen oder aus Sicherheitsgründen vorübergehend gesperrt werden.",
          },
          {
            type: "steps",
            items: [
              "Warten Sie einige Zeit, bevor Sie sich erneut anmelden, wenn zu viele Anmeldeversuche unternommen wurden.",
              "Setzen Sie Ihr Passwort zurück, wenn Sie vermuten, dass jemand anderes auf Ihr Konto zugegriffen hat.",
              "Befolgen Sie die Anweisungen auf dem Anmeldebildschirm.",
              "Kontaktieren Sie den Support, wenn Ihr Konto weiterhin gesperrt ist.",
            ],
          },
        ],
      },

      verificationCodeIssues: {
        title: "Probleme mit dem Bestätigungscode",
        body: [
          {
            type: "paragraph",
            text: "Bestätigungscodes funktionieren möglicherweise nicht, wenn sie abgelaufen sind, falsch eingegeben wurden oder zu häufig angefordert wurden.",
          },
          {
            type: "bullets",
            items: [
              "Verwenden Sie den zuletzt erhaltenen Bestätigungscode.",
              "Stellen Sie sicher, dass keine Leerzeichen oder Tippfehler vorhanden sind.",
              "Warten Sie einen Moment, bevor Sie einen neuen Code anfordern.",
            ],
          },
        ],
      },

      loginNewDevice: {
        title: "Anmeldung auf einem neuen Gerät",
        body: [
          {
            type: "paragraph",
            text: "Wenn Sie sich auf einem neuen Gerät anmelden, kann zum Schutz Ihres Kontos eine zusätzliche Bestätigung erforderlich sein.",
          },
          {
            type: "bullets",
            items: [
              "Bestätigen Sie, dass der Anmeldeversuch von Ihnen stammt.",
              "Schließen Sie alle erforderlichen Bestätigungsschritte ab.",
              "Bestätigen Sie keine Anmeldeversuche, die Sie nicht erkennen.",
              "Ändern Sie Ihr Passwort, wenn Sie unbekannte Aktivitäten feststellen.",
            ],
          },
        ],
      },

      suspiciousLoginActivity: {
        title: "Verdächtige Anmeldeaktivitäten",
        body: [
          {
            type: "paragraph",
            text: "Verdächtige Anmeldeaktivitäten können darauf hinweisen, dass jemand versucht hat, auf Ihr Konto zuzugreifen.",
          },
          {
            type: "bullets",
            items: [
              "Ändern Sie Ihr Passwort sofort.",
              "Überprüfen Sie – sofern verfügbar – Ihre aktiven Sitzungen oder verbundenen Geräte.",
              "Aktivieren Sie die Zwei-Faktor-Authentifizierung.",
              "Kontaktieren Sie den Support, wenn Sie glauben, dass Ihr Konto kompromittiert wurde.",
            ],
          },
        ],
      },

   //////////////////// 
      //MyProfile
      ////////////////////
      findingMyProfile: {
        title: "Wo finde ich die Informationen zu Mein Profil?",
        body: [
          {
            type: "paragraph",
            text: "„Mein Profil“ ist Ihr persönlicher Bereich auf der Plattform, in dem Sie Ihre Profilinformationen verwalten, Ihre Aktivitäten einsehen und auf profilbezogene Funktionen zugreifen können.",
          },
          {
            type: "steps",
            items: [
              "Auf der Website finden Sie „Mein Profil“ in der linken Seitenleiste.",
              "In der mobilen App finden Sie „Mein Profil“ im Menü.",
              "Dort können Sie Ihre Profilinformationen verwalten und Ihre Aktivitäten einsehen.",
            ],
          },
          {
            type: "bullets",
            items: [
              "Profilbild hochladen oder ändern.",
              "Biografie bearbeiten.",
              "Standort hinzufügen oder ändern.",
              "Beiträge anzeigen.",
              "Gefällt mir-Angaben anzeigen.",
              "Follower und gefolgte Profile anzeigen.",
            ],
          },
          {
            type: "note",
            text: "Die in Ihrem Profil angezeigten Informationen können – abhängig von Ihren Datenschutzeinstellungen – für andere Nutzer sichtbar sein.",
          },
        ],
      },

      profileName: {
        title: "Profilname",
        body: [
          {
            type: "paragraph",
            text: "Ihr Profilname ist der öffentliche Name, der auf Ihrem Profil sowie neben Ihren Beiträgen auf der gesamten Plattform angezeigt wird.",
          },
          {
            type: "bullets",
            items: [
              "Jeder Profilname muss eindeutig sein.",
              "Ihr Profilname wird während der Registrierung festgelegt.",
              "Andere Nutzer können Ihren Profilnamen verwenden, um Ihr Profil zu finden und zu erkennen.",
              "Profilnamen können nach der Registrierung nicht mehr geändert werden.",
            ],
          },
          {
            type: "note",
            text: "Wählen Sie Ihren Profilnamen bei der Registrierung sorgfältig aus, da er später nicht mehr geändert werden kann.",
          },
        ],
      },

      changeProfilePicture: {
        title: "Profilbild ändern",
        body: [
          {
            type: "paragraph",
            text: "Ihr Profilbild hilft anderen Nutzern, Ihr Konto zu erkennen, und wird auf Ihrem Profil sowie auf der gesamten Plattform angezeigt.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie „Mein Profil“.",
              "Wählen Sie „Profil bearbeiten“.",
              "Wählen Sie ein neues Bild aus.",
              "Überprüfen Sie die Vorschau Ihres Profilbildes.",
              "Speichern Sie Ihre Änderungen.",
            ],
          },
        ],
      },

      editBio: {
        title: "Biografie bearbeiten",
        body: [
          {
            type: "paragraph",
            text: "Ihre Biografie ist eine kurze Beschreibung, die auf Ihrem Profil angezeigt wird und anderen Nutzern helfen kann, mehr über Sie zu erfahren.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie „Mein Profil“.",
              "Wählen Sie „Profil bearbeiten“.",
              "Aktualisieren Sie den Text Ihrer Biografie.",
              "Speichern Sie Ihre Änderungen.",
            ],
          },
          {
            type: "note",
            text: "Vermeiden Sie es, vertrauliche oder sensible persönliche Informationen in Ihrer Biografie anzugeben.",
          },
        ],
      },

////////////////////
//Kontoeinstellungen
////////////////////

      settingsOverview: {
        title: "Übersicht der Kontoeinstellungen",
        body: [
          {
            type: "paragraph",
            text: "Die Kontoeinstellungen sind der Bereich, in dem Sie wichtige Kontoeinstellungen und Zugriffsoptionen verwalten.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie auf der Website die „Einstellungen“ über die linke Seitenleiste. In der mobilen App öffnen Sie die „Einstellungen“ über das Menü.",
              "Wählen Sie in der Einstellungsübersicht oder Seitenleiste „Kontoeinstellungen“ aus.",
            ],
          },
          {
            type: "bullets",
            items: [
              "Profilnamen teilen.",
              "E-Mail-Adresse ändern.",
              "Passwort ändern.",
              "Sprache auswählen.",
              "Benachrichtigungseinstellungen verwalten.",
              "Profil deaktivieren oder reaktivieren.",
            ],
          },
        ],
      },

      shareProfileName: {
        title: "Profilnamen teilen",
        body: [
          {
            type: "paragraph",
            text: "Ihr Profilname ist der Name, mit dem andere Nutzer Ihr Konto finden oder erkennen können.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie die „Kontoeinstellungen“ in der Einstellungsübersicht oder Seitenleiste.",
              "Ihr Profilname wird oben auf der Seite „Kontoeinstellungen“ angezeigt.",
              "Geben Sie die E-Mail-Adresse des Empfängers ein, um Ihren Profilnamen zu teilen.",
              "Teilen Sie ihn nur mit Personen, mit denen Sie sich verbinden möchten.",
              "Überprüfen Sie Ihre Datenschutzeinstellungen, wenn Ihr Profil nicht allgemein sichtbar sein soll.",
            ],
          },
        ],
      },

      changeEmail: {
        title: "E-Mail-Adresse ändern",
        body: [
          {
            type: "paragraph",
            text: "Sie können die mit Ihrem Konto verknüpfte E-Mail-Adresse in den Kontoeinstellungen ändern.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie die „Kontoeinstellungen“ in der Einstellungsübersicht oder Seitenleiste.",
              "Geben Sie Ihre aktuelle E-Mail-Adresse und anschließend Ihre neue E-Mail-Adresse ein.",
              "Wählen Sie „E-Mail-Adresse ändern“.",
              "Bestätigen Sie die Änderung mit dem sechsstelligen Bestätigungscode, der an Ihre neue E-Mail-Adresse gesendet wurde.",
            ],
          },
        ],
      },

      changePassword: {
        title: "Passwort ändern",
        body: [
          {
            type: "paragraph",
            text: "Wenn Sie Ihr Passwort regelmäßig ändern, können Sie die Sicherheit Ihres Kontos erhöhen.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie die „Kontoeinstellungen“ in der Einstellungsübersicht oder Seitenleiste.",
              "Wählen Sie „Passwort ändern“.",
              "Geben Sie Ihr aktuelles Passwort ein und klicken Sie auf „Weiter“.",
              "Erstellen Sie ein neues sicheres Passwort und bestätigen Sie es.",
              "Speichern Sie die Änderung und melden Sie sich bei Bedarf erneut an.",
            ],
          },
        ],
      },

      selectLanguage: {
        title: "Sprache auswählen",
        body: [
          {
            type: "paragraph",
            text: "Die Spracheinstellungen legen fest, welche Sprache – sofern verfügbar – für Menüs, Beschriftungen, Meldungen und Hilfeseiten verwendet wird.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie die „Kontoeinstellungen“ in der Einstellungsübersicht oder Seitenleiste.",
              "Wählen Sie „Sprache“.",
              "Wählen Sie Ihre bevorzugte Sprache aus.",
              "Sie können die Sprache auch auf der Website sowie auf der Anmelde- und Registrierungsseite ändern.",
            ],
          },
        ],
      },

      notificationSettings: {
        title: "Benachrichtigungseinstellungen",
        body: [
          {
            type: "paragraph",
            text: "Mit den Benachrichtigungseinstellungen legen Sie fest, welche Aktualisierungen und Hinweise Sie erhalten möchten.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie die „Kontoeinstellungen“ in der Einstellungsübersicht oder Seitenleiste.",
              "Wählen Sie „Benachrichtigungen“.",
              "Aktivieren oder deaktivieren Sie die gewünschten Benachrichtigungsarten.",
              "Überprüfen Sie die Benachrichtigungsberechtigungen Ihres Geräts, falls keine Benachrichtigungen angezeigt werden.",
            ],
          },
        ],
      },

      deactivateProfile: {
        title: "Profil deaktivieren",
        body: [
          {
            type: "paragraph",
            text: "Durch das Deaktivieren Ihres Profils werden Ihr Profil und Ihre Beiträge für andere Nutzer ausgeblendet, ohne Ihr Konto dauerhaft zu löschen.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie die „Kontoeinstellungen“ in der Einstellungsübersicht oder Seitenleiste.",
              "Wählen Sie am Ende der Seite „Profil deaktivieren“.",
              "Geben Sie Ihr aktuelles Kontopasswort ein und klicken Sie auf „Deaktivieren“.",
              "Wenn das Passwort korrekt ist, wird Ihr Profil deaktiviert und ist nicht mehr öffentlich sichtbar.",
            ],
          },
          {
            type: "note",
            text: "Sie können Ihr Profil jederzeit wieder aktivieren, indem Sie zu den Kontoeinstellungen zurückkehren und „Profil reaktivieren“ auswählen.",
          },
        ],
      },

      reactivateProfile: {
        title: "Profil reaktivieren",
        body: [
          {
            type: "paragraph",
            text: "Wenn Ihr Profil deaktiviert wurde, können Sie es jederzeit wieder aktivieren.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie die „Kontoeinstellungen“ in der Einstellungsübersicht oder Seitenleiste.",
              "Wählen Sie am Ende der Seite „Profil reaktivieren“.",
              "Ihr Profil wird wieder aktiviert und Ihre Beiträge werden erneut sichtbar.",
            ],
          },
        ],
      },

   

      ////////////////////
      //Data & Privacy
      ////////////////////
      dataPrivacyOverview: {
        title: "Übersicht zu Daten & Datenschutz",
        body: [
          {
            type: "paragraph",
            text: "Im Bereich „Daten & Datenschutz“ erhalten Sie Informationen und Kontrolle über Ihre Datenschutzeinstellungen, Kontodaten, Löschung, Datenspeicherung und Möglichkeiten zum Datenzugriff.",
          },
          {
            type: "bullets",
            items: [
              "Überprüfen Sie Ihre ersten Datenschutzeinstellungen nach der Registrierung.",
              "Passen Sie Ihre Datenschutzeinstellungen für Sichtbarkeit und Interaktionen an.",
              "Erfahren Sie, was nach der Löschung Ihres Kontos geschieht.",
              "Informieren Sie sich über Datenspeicherung und den Download Ihrer Kontodaten.",
            ],
          },
        ],
      },

      whoCanSeeProfile: {
        title: "Wer kann mein Profil sehen?",
        body: [
          {
            type: "paragraph",
            text: "Die Sichtbarkeit Ihres Profils hängt von Ihren Datenschutzeinstellungen und der Darstellung von Benutzerprofilen auf der Plattform ab.",
          },
          {
            type: "bullets",
            items: [
              "Öffentliche Profile können für andere Nutzer sichtbar sein.",
              "Einige Profildaten können zusammen mit Beiträgen, Nachrichten oder Interaktionen angezeigt werden.",
              "Überprüfen Sie Ihre Datenschutzeinstellungen, um die Sichtbarkeit – sofern verfügbar – zu steuern.",
            ],
          },
        ],
      },

      adjustPrivacySettings: {
        title: "Datenschutzeinstellungen anpassen",
        body: [
          {
            type: "paragraph",
            text: "Mit den Datenschutzeinstellungen können Sie Ihre Einwilligungen für standortbezogene Funktionen, Analysen und Push-Benachrichtigungen verwalten.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie „Daten & Datenschutz“ in den Einstellungen.",
              "Überprüfen Sie Ihre Einstellungen für Standort, Analysen und Push-Benachrichtigungen.",
              "Aktivieren oder deaktivieren Sie jede Option nach Bedarf.",
              "Speichern Sie Ihre Änderungen, bevor Sie die Seite verlassen.",
            ],
          },
        ],
      },

      firstPrivacyChoice: {
        title: "Erste Datenschutzeinstellungen nach der Registrierung",
        body: [
          {
            type: "paragraph",
            text: "Nach der Registrierung werden Sie möglicherweise aufgefordert, Ihre Datenschutzeinstellungen zu überprüfen, bevor Sie die Plattform zum ersten Mal nutzen.",
          },
          {
            type: "bullets",
            items: [
              "Die Standortfreigabe legt fest, ob standortbezogene Funktionen genutzt werden dürfen.",
              "Die Einwilligung zu Analysen legt fest, ob Nutzungsdaten für Analysen erfasst werden dürfen.",
              "Die Einwilligung zu Push-Benachrichtigungen legt fest, ob Sie Benachrichtigungen erhalten dürfen.",
            ],
          },
          {
            type: "note",
            text: "Sie können fortfahren, auch wenn alle Optionen deaktiviert sind. Diese Einstellungen können später jederzeit im Bereich „Daten & Datenschutz“ geändert werden.",
          },
        ],
      },

      deleteAccount: {
        title: "Konto löschen",
        body: [
          {
            type: "paragraph",
            text: "Durch das Löschen Ihres Kontos verlieren Sie dauerhaft den Zugriff auf Ihr Konto. Kontobezogene Informationen werden gelöscht oder anonymisiert.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie die Kontoverwaltung.",
              "Wählen Sie „Konto löschen“.",
              "Geben Sie Ihr aktuelles Passwort ein, um die Löschung anzufordern.",
              "Überprüfen Sie Ihr E-Mail-Postfach auf den sechsstelligen Löschungscode.",
              "Geben Sie den Code ein, um die Löschung zu bestätigen.",
              "Bestätigen Sie den Vorgang nur, wenn Sie wissen, dass die Löschung dauerhaft sein kann.",
            ],
          },
          {
            type: "note",
            text: "Einige Informationen können aus rechtlichen, sicherheitsrelevanten, moderationsbezogenen, betrieblichen oder Sicherungsgründen weiterhin gespeichert bleiben.",
          },
        ],
      },

      accountDeletionProcess: {
        title: "Was passiert, wenn ein Konto gelöscht wird?",
        body: [
          {
            type: "paragraph",
            text: "Wenn ein Konto gelöscht wird, wird der Zugriff auf das Konto entfernt. Profilbezogene Informationen können gelöscht, anonymisiert oder vom Konto getrennt werden.",
          },
          {
            type: "bullets",
            items: [
              "Sie verlieren den Zugriff auf Ihr Konto, Ihr Profil und Ihre Einstellungen.",
              "Ihre Beiträge, Entwürfe, Musiktitel, Benachrichtigungen, Abonnements und hochgeladenen Medien können gelöscht werden.",
              "Nachrichten mit anderen Nutzern können für diese weiterhin sichtbar bleiben, Ihre Absenderinformationen können jedoch anonymisiert werden.",
              "Einige Datensätze oder Sicherungskopien können aus rechtlichen, sicherheitsrelevanten, moderationsbezogenen, betrieblichen oder Sicherungsgründen erhalten bleiben.",
            ],
          },
        ],
      },

      dataRetention: {
        title: "Datenspeicherung",
        body: [
          {
            type: "paragraph",
            text: "Die Datenspeicherung beschreibt, wie lange kontobezogene Informationen aufbewahrt werden, bevor sie gelöscht, anonymisiert oder überschrieben werden.",
          },
          {
            type: "bullets",
            items: [
              "Kontodaten können gespeichert werden, solange Ihr Konto aktiv ist.",
              "Einige Daten können nach der Löschung aus Sicherheits- oder Rechtsgründen weiterhin aufbewahrt werden.",
              "Sicherungskopien können für einen begrenzten Zeitraum bestehen bleiben.",
              "Die Aufbewahrungsdauer kann von der Art der Informationen abhängen.",
            ],
          },
        ],
      },

      downloadAccountData: {
        title: "Kontodaten herunterladen",
        body: [
          {
            type: "paragraph",
            text: "Beim Herunterladen Ihrer Kontodaten erhalten Sie eine Kopie bestimmter Informationen, die mit Ihrem Konto verknüpft sind.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie „Daten & Datenschutz“ in den Einstellungen.",
              "Wählen Sie „Ihre Daten herunterladen“.",
              "Folgen Sie dem Anforderungsprozess.",
              "Warten Sie gegebenenfalls, bis die Exportdatei erstellt wurde.",
            ],
          },
        ],
      },


//////////////////////////////////
/////////////Security/////////////
//////////////////////////////////
        securityOverview: {
        title: "Sicherheitsübersicht",
        body: [
          {
            type: "paragraph",
            text: "Die Sicherheitseinstellungen helfen dabei, Ihr Konto vor unbefugtem Zugriff und verdächtigen Aktivitäten zu schützen.",
          },
          {
            type: "bullets",
            items: [
              "Verwenden Sie ein sicheres Passwort.",
              "Aktivieren Sie die Zwei-Faktor-Authentifizierung.",
              "Überprüfen Sie verdächtige Anmeldeaktivitäten.",
              "Melden Sie sich bei Bedarf von allen Geräten ab.",
              "Teilen Sie niemals Passwörter, Links zum Zurücksetzen oder Bestätigungscodes.",
            ],
          },
        ],
      },

      twoFactorAuthentication: {
        title: "Zwei-Faktor-Authentifizierung (2FA)",
        body: [
          {
            type: "paragraph",
            text: "Die Zwei-Faktor-Authentifizierung bietet zusätzlichen Schutz, indem bei der Anmeldung ein sechsstelliger Bestätigungscode per E-Mail erforderlich ist.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie „Sicherheit“ in der Einstellungsübersicht oder Seitenleiste.",
              "Wählen Sie „Zwei-Faktor-Authentifizierung“.",
              "Geben Sie Ihr aktuelles Passwort ein, um die Einrichtung zu starten.",
              "Überprüfen Sie Ihr E-Mail-Postfach auf den sechsstelligen Einrichtungscode.",
              "Geben Sie den Code ein, um die 2FA zu aktivieren.",
              "Speichern Sie die Wiederherstellungscodes, die nach der Einrichtung angezeigt werden.",
            ],
          },
          {
            type: "note",
            text: "Die Wiederherstellungscodes werden nur einmal angezeigt. Bewahren Sie sie sicher auf und teilen Sie sie mit niemandem.",
          },
        ],
      },

      how2faWorks: {
        title: "So funktioniert die 2FA",
        body: [
          {
            type: "paragraph",
            text: "Die 2FA hilft zu bestätigen, dass Sie sich tatsächlich anmelden, selbst wenn jemand anderes Ihr Passwort kennt.",
          },
          {
            type: "bullets",
            items: [
              "Sie geben wie gewohnt Ihre E-Mail-Adresse und Ihr Passwort ein.",
              "Wenn die 2FA aktiviert ist, wird ein sechsstelliger Code an Ihre hinterlegte E-Mail-Adresse gesendet.",
              "Sie müssen diesen Code eingeben, bevor die Anmeldung abgeschlossen werden kann.",
              "Ist der Code abgelaufen oder falsch, wird die Anmeldung nicht fortgesetzt.",
            ],
          },
          {
            type: "note",
            text: "Bewahren Sie Ihre Wiederherstellungscodes sicher auf. Personen mit Zugriff auf diese Codes könnten möglicherweise auf Ihr Konto zugreifen.",
          },
        ],
      },

      disableTwoFactorAuthentication: {
        title: "Zwei-Faktor-Authentifizierung deaktivieren",
        body: [
          {
            type: "paragraph",
            text: "Sie können die Zwei-Faktor-Authentifizierung (2FA) deaktivieren, wenn Sie bei der Anmeldung keine zusätzliche Bestätigung mehr verwenden möchten.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie die Einstellungen und wählen Sie „Sicherheit“ in der Seitenleiste aus.",
              "Wählen Sie „Zwei-Faktor-Authentifizierung deaktivieren“.",
              "Geben Sie Ihr aktuelles Passwort ein.",
              "Bestätigen Sie, dass Sie die 2FA deaktivieren möchten.",
              "Nach der Bestätigung wird die 2FA für Ihr Konto deaktiviert.",
            ],
          },
          {
            type: "note",
            text: "Durch das Deaktivieren der 2FA wird die Sicherheit Ihres Kontos reduziert. Personen mit Zugriff auf Ihre E-Mail-Adresse und Ihr Passwort könnten möglicherweise auf Ihr Konto zugreifen.",
          },
        ],
      },

      keepingAccountSecure: {
        title: "So bleibt Ihr Konto sicher",
        body: [
          {
            type: "paragraph",
            text: "Gute Sicherheitsgewohnheiten helfen dabei, Ihr Konto vor unbefugtem Zugriff zu schützen.",
          },
          {
            type: "bullets",
            items: [
              "Verwenden Sie ein sicheres und einzigartiges Passwort.",
              "Aktivieren Sie die 2FA, sofern verfügbar.",
              "Teilen Sie niemals Anmeldecodes oder Links zum Zurücksetzen Ihres Passworts.",
              "Melden Sie sich von gemeinsam genutzten Geräten ab.",
              "Achten Sie auf Phishing-Nachrichten oder gefälschte Anmeldeseiten.",
            ],
          },
        ],
      },

      logoutAllDevices: {
        title: "Von allen Geräten abmelden",
        body: [
          {
            type: "paragraph",
            text: "Durch das Abmelden von allen Geräten werden alle aktiven Sitzungen beendet. Dies schützt Ihr Konto, wenn Sie ein gemeinsam genutztes Gerät verwendet haben oder einen unbefugten Zugriff vermuten.",
          },
          {
            type: "steps",
            items: [
              "Öffnen Sie „Sicherheit“ in der Einstellungsübersicht oder Seitenleiste.",
              "Wählen Sie „Von allen Geräten abmelden“.",
              "Bestätigen Sie die Aktion, falls Sie dazu aufgefordert werden.",
              "Melden Sie sich anschließend auf den Geräten wieder an, die Sie weiterhin verwenden möchten.",
              "Ändern Sie anschließend Ihr Passwort, wenn Sie einen unbefugten Zugriff vermuten.",
            ],
          },
        ],
      },



      ////////////////////////
      //Profile Management
      ///////////////////////
      profileManagementOverview: {
        title: "Übersicht zur Profilverwaltung",
        body: [
          {
            type: "paragraph",
            text: "Mit der Profilverwaltung können Sie Ihre Interaktionen mit anderen Nutzern steuern und profilbezogene Aktivitäten verwalten.",
          },
          {
            type: "bullets",
            items: [
              "Blockieren Sie Nutzer, wenn Sie keine Interaktionen mit ihnen wünschen.",
              "Melden Sie Nutzer, die gegen die Plattformregeln verstoßen.",
              "Überprüfen Sie Ihre Follower.",
              "Überprüfen Sie die Profile, denen Sie folgen.",
              "Nutzen Sie Datenschutz- und Sicherheitseinstellungen zusammen mit den Funktionen der Profilverwaltung.",
            ],
          },
        ],
      },

      blockUser: {
        title: "Benutzer blockieren",
        body: [
          {
            type: "paragraph",
            text: "Durch das Blockieren eines Nutzers können Sie dessen Möglichkeiten einschränken, Sie zu kontaktieren oder mit Ihrem Profil zu interagieren.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie das Profil des Nutzers oder dessen Interaktionsmenü.",
              "Wählen Sie „Blockieren“, sofern verfügbar.",
              "Bestätigen Sie die Aktion.",
              "Sie können blockierte Nutzer – sofern unterstützt – in den Datenschutzeinstellungen verwalten.",
            ],
          },
        ],
      },

      reportUser: {
        title: "Benutzer melden",
        body: [
          {
            type: "paragraph",
            text: "Durch das Melden eines Nutzers informieren Sie die Plattform über Verhalten oder Inhalte, die gegen die Regeln verstoßen oder Sicherheitsbedenken verursachen könnten.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie das Profil, die Nachricht oder das Inhaltsmenü des Nutzers.",
              "Wählen Sie „Melden“.",
              "Wählen Sie den Grund aus, der das Problem am besten beschreibt.",
              "Fügen Sie bei Bedarf weitere Informationen hinzu.",
            ],
          },
        ],
      },

      myFollowers: {
        title: "Meine Follower",
        body: [
          {
            type: "paragraph",
            text: "Unter „Meine Follower“ sehen Sie alle Nutzer, die Ihrem Profil folgen.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie Ihr Profil.",
              "Wählen Sie „Follower“.",
              "Überprüfen Sie, wer Ihrem Profil folgt.",
              "Blockieren oder melden Sie Nutzer bei Bedarf.",
            ],
          },
        ],
      },

      myFollowees: {
        title: "Profile, denen ich folge",
        body: [
          {
            type: "paragraph",
            text: "Unter „Profile, denen ich folge“ sehen Sie alle Nutzer, deren Profilen Sie folgen.",
          },
          {
            type: "bullets",
            items: [
              "Öffnen Sie Ihr Profil.",
              "Wählen Sie „Folge ich“.",
              "Überprüfen Sie die Profile, denen Sie folgen.",
              "Entfolgen Sie Nutzern, denen Sie nicht mehr folgen möchten.",
            ],
          },
        ],
      },

///////////////////////////////////////////
/////////Support & Fehlerbehebung//////////
///////////////////////////////////////////

      contactSupport: {
        title: "Support kontaktieren",
        body: [
          {
            type: "paragraph",
            text: "Kontaktieren Sie den Support, wenn Sie ein Kontoproblem nicht mithilfe der verfügbaren Einstellungen oder Hilfeartikel lösen können.",
          },
          {
            type: "bullets",
            items: [
              "Beschreiben Sie das Problem möglichst genau.",
              "Geben Sie an, wann das Problem erstmals aufgetreten ist.",
              "Fügen Sie bei Bedarf Screenshots hinzu.",
              "Teilen Sie niemals Ihr Passwort oder private Bestätigungscodes mit.",
            ],
          },
        ],
      },

      reportIssue: {
        title: "Technisches Problem melden",
        body: [
          {
            type: "paragraph",
            text: "Zu technischen Problemen gehören beispielsweise fehlerhafte Seiten, fehlgeschlagene Aktionen, Ladeprobleme oder unerwartete Fehlermeldungen.",
          },
          {
            type: "bullets",
            items: [
              "Beschreiben Sie, was Sie gerade tun wollten.",
              "Geben Sie – sofern bekannt – Ihr Gerät sowie die Browser- oder App-Version an.",
              "Fügen Sie Screenshots oder Fehlermeldungen hinzu.",
              "Versuchen Sie zunächst, die Seite zu aktualisieren oder die App neu zu starten.",
            ],
          },
        ],
      },

      websiteIssues: {
        title: "Probleme mit der Website",
        body: [
          {
            type: "paragraph",
            text: "Probleme mit der Website können durch Browsereinstellungen, Netzwerkprobleme, zwischengespeicherte Dateien oder vorübergehende Dienstunterbrechungen verursacht werden.",
          },
          {
            type: "bullets",
            items: [
              "Aktualisieren Sie die Seite.",
              "Leeren Sie bei Bedarf den Browser-Cache.",
              "Versuchen Sie es mit einem anderen Browser oder einem privaten Fenster.",
              "Überprüfen Sie Ihre Internetverbindung.",
            ],
          },
        ],
      },

      accountRecovery: {
        title: "Kontowiederherstellung",
        body: [
          {
            type: "paragraph",
            text: "Die Kontowiederherstellung hilft Ihnen, den Zugriff auf Ihr Konto wiederzuerlangen, wenn Sie sich nicht anmelden können, keinen Zugriff mehr auf Ihre E-Mail-Adresse haben oder vermuten, dass Ihr Konto kompromittiert wurde.",
          },
          {
            type: "bullets",
            items: [
              "Versuchen Sie zunächst, Ihr Passwort zurückzusetzen.",
              "Verwenden Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse.",
              "Geben Sie bei der Kontaktaufnahme mit dem Support korrekte Informationen an.",
              "Erstellen Sie nur dann mehrere Wiederherstellungsanfragen, wenn dies unbedingt erforderlich ist.",
            ],
          },
        ],
      },

      appealRestriction: {
        title: "Einschränkung anfechten",
        body: [
          {
            type: "paragraph",
            text: "Wenn Ihr Konto eingeschränkt wurde, können Sie die Entscheidung – abhängig vom Grund der Einschränkung und den Plattformregeln – möglicherweise anfechten.",
          },
          {
            type: "bullets",
            items: [
              "Lesen Sie die Mitteilung über die Einschränkung, sofern verfügbar.",
              "Befolgen Sie die Anweisungen für den Einspruch.",
              "Erläutern Sie, warum die Einschränkung Ihrer Meinung nach überprüft werden sollte.",
              "Warten Sie auf die Rückmeldung des Supports oder der Moderation.",
            ],
          },
        ],
      },

      faq: {
        title: "Häufig gestellte Fragen",
        body: [
          {
            type: "paragraph",
            text: "Die häufig gestellten Fragen bieten Antworten auf typische Kontoprobleme und kurze Erklärungen an einem zentralen Ort.",
          },
          {
            type: "bullets",
            items: [
              "Verwenden Sie die Suche oder die Themen in der Seitenleiste, um die passende Hilfeseite zu finden.",
              "Überprüfen Sie zunächst die Bereiche Registrierung, Anmeldung, Einstellungen, Datenschutz und Kontoverwaltung.",
              "Kontaktieren Sie den Support, wenn die verfügbaren Hilfeartikel Ihr Problem nicht lösen.",
            ],
          },
        ],
      },
    },
  },
} as const;

export default accountSupport;